import { inject, InjectionToken } from '@angular/core';
import { CompanyService } from '@services/company/company.service';
import { environment } from '@environment';

export const API_URL = new InjectionToken('api url', {
  providedIn: 'root',
  factory: () => environment.apiUrl(inject(CompanyService).name),
});
